import { connect } from "react-redux";
import { getList } from "actions/Auth";
import { TrangChu } from "components/TrangChu";

const mapStateToProps = (state) => ({
  TrangChu: state.TrangChu,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getList: () => dispatch(getList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrangChu);
